import { getRecentLea } from './service';
import commonUtil from '../../common-util/index.js';

const targetUrlprefix = window.location.origin;
const i18n = commonUtil.i18n;

/**
 * 跳转 项目详情 目录
 * @param {String} projectId
 */
export const toCatalog = (projectId) => {
  window.location.href = `${targetUrlprefix}/o2o/#/project/detail/${projectId}`;
};

// 跳转策略
const skipStrategy = {
  '1': task => {
    // 面授
    if (task.subType === '1') {
      return `/flipstu/#/index/${task.targetId}?&bizId=${task.projectId}&taskId=${task.id}&appCode=${ task.gwnlUrl ? 'gwnl' : 'o2o' }&trackId=${task.trackId}&btid=${task.batchId || ''}`;
    }
    return `/o2o/#/face/${task.id}?trackId=${task.trackId}&btid=${task.batchId || ''}`;
  },
  '2': ({targetId, projectId, result, trackId, batchId, gwnlUrl}, vm) => {
    // 考试
    if (!result) {
      return vm.$message.info(i18n.t('pc_biz_o2o_tip_task_sync'));
    }
    return `/ote/#/exampreview?arrangeId=${targetId}&masterId=${projectId}&masterType=${ gwnlUrl ? 4 : 1 }&trackId=${trackId}&btid=${batchId || ''}`;
  },
  '3,4,5': ({type, id: taskId, trackId, projectId, batchId}) => {
    // 调查、评价、投票
    let nameStr = (type === 3 ? 'survey' : type === 4 ? 'eva' : 'vote');
    return `/o2o/#/${nameStr}/${taskId}?trackId=${trackId}&projectId=${projectId}&btid=${batchId || ''}`;
  },
  '6': task => {
    // 作业
    return `/o2o/#/homework/${task.id}?trackId=${task.trackId}&btid=${task.batchId || ''}`;
  },
  '7': task => {
    // 活动
    return `/o2o/#/activity/${task.id}?trackId=${task.trackId}&btid=${task.batchId || ''}`;
  },
  '14': task => {
    // 外部链接
    return `/o2o/#/other/${task.id}?trackId=${task.trackId}&btid=${task.batchId || ''}`;
  },
  '8,9,10,11,12,13,16,22': ({ targetId, id: taskId, projectId, result, trackId, orgId, batchId, gwnlUrl }, vm) => { // 知识
    // 文档 课程 微课 视频 音频 scorm html
    if (!result) {
      return vm.$message.info(i18n.t('pc_biz_o2o_tip_task_sync'));
    }
    return `/kng/#/scan?kngId=${targetId}&targetId=${projectId}&taskId=${taskId}&targetCode=${ gwnlUrl ? 'gwnl' : 'o2o' }&originOrgId=${orgId || ''}&trackId=${trackId}&btid=${batchId || ''}`;
  },
  '17': task => {
    // 直播
    return `/tlive/#/livedetail/${task.targetId}?targetId=${task.projectId}&taskId=${task.id}&trackId=${task.trackId}&btid=${task.batchId || ''}`;
  },
  '19': task => {
    // 练习
    return `/ote/#/practicepreview?praId=${task.targetId}&trackId=${task.trackId}&btid=${task.batchId || ''}`;
  },
  '21': task => {
    // 鉴定
    return `/o2o/#/identification/${task.id}?pid=${task.projectId}&trackId=${task.trackId}&btid=${task.batchId || ''}`;
  },
  '23': task => {
    // 考核
    return `/gwnl/#/web/examine/${task.projectId}?knowledgeId=${task.targetId}&trackId=${task.trackId}&btid=${task.batchId || ''}`;
  }
};

/**
 * 切换任务， 检验通过后跳转
 * @param {Object} data 任务信息
 */
export const skipTask = (data, vm) => {
  let type = (data.type || '').toString();
  if (data.resultRepeatFlag !== 2) data.batchId = '';
  let key = Object.keys(skipStrategy).find(key =>
    key.split(',').includes(type)
  );
  key && getRecentLea({ taskId: data.id, projectId: data.projectId }).finally(() => {
    let url = `${targetUrlprefix}${skipStrategy[key](data, vm)}`;
    if (data.gwnlUrl) {
      url += `&gwnlUrl=${data.gwnlUrl}`;
    }
    window.location.href = url;
  });
};
